import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [
  { key: "name", label: "Name *", placeholder: "Nikhil Kapoor / Kapoor & Sethi Associates", span: true },
  { key: "designation", label: "Designation / role", placeholder: "Partner, Advocate-on-Record…" },
  { key: "org", label: "Firm or organisation", placeholder: "Kapoor & Sethi Associates" },
  { key: "address", label: "Address", placeholder: "Office address as it should print", span: true },
  { key: "city", label: "City" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone / WhatsApp", mono: true },
  { key: "tax_id", label: "GST / tax no.", mono: true },
];

export const BilledToFields = ({ value, onChange, testPrefix = "billed-to" }) => (
  <div className="grid gap-4 sm:grid-cols-2" data-testid={`${testPrefix}-fields`}>
    {FIELDS.map((f) => (
      <div key={f.key} className={`space-y-2 ${f.span ? "sm:col-span-2" : ""}`}>
        <Label className="label-caps">{f.label}</Label>
        <Input
          value={value?.[f.key] ?? ""}
          onChange={(e) => onChange({ [f.key]: e.target.value })}
          placeholder={f.placeholder}
          className={`rounded-sm ${f.mono ? "num" : ""}`.trim()}
          data-testid={`${testPrefix}-${f.key.replace(/_/g, "-")}`}
        />
      </div>
    ))}
  </div>
);
